import AppRouter from "./routers/AppRouter";

const App = () => {
  return (
    <div className="app-wrapper">
      <AppRouter />
    </div>
  );
};

export default App;
